module.exports = __webpack_public_path__ + "static/media/mainscreen-ashok-leyland-1.0ef6bf23.png";